export default "__VITE_ASSET__DTCeW4E0__"